import { useTranslation } from 'react-i18next';
import { trackGTMEvent } from './GoogleTagManager';
import { trackEventMp } from './Mixpanel';
import { trackEvent } from './Hotjar';

export const TrustBadges = () => {
  const { t } = useTranslation();
  
  const handleProductHuntClick = () => {
    trackGTMEvent('product_hunt_badge_click', {
      event_category: 'engagement',
      event_label: 'footer_badge',
      source: 'footer'
    });
    trackEventMp('product_hunt_badge_click');
    trackEvent('product_hunt_badge_click');
  };

  const handleAIForThatClick = () => {
    trackGTMEvent('ai_for_that_badge_click', {
      event_category: 'engagement',
      event_label: 'footer_badge',
      source: 'footer'
    });
    trackEventMp('ai_for_that_badge_click');
    trackEvent('ai_for_that_badge_click');
  };
  
  return (
    <div className="flex flex-col items-center gap-4 py-8 border-t border-border/50">
      <p className="text-sm text-muted-foreground">{t('trustBadges.seenOn')}</p>
      <div className="flex flex-wrap items-center justify-center gap-4">
        {/* Product Hunt Badge */}
        <a 
          href="https://www.producthunt.com/products/newsforyou-2?embed=true&utm_source=badge-featured&utm_medium=badge&utm_source=badge-newsforyou&#0045;2" 
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleProductHuntClick}
          className="inline-block opacity-70 hover:opacity-100 transition-opacity duration-300"
        >
          <img 
            src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=1014714&theme=dark&t=1757816240475"
            alt={t('header.productHuntBadgeAlt')}
            className="w-40 h-8 object-contain"
            width="160" 
            height="32"
            loading="lazy"
          />
        </a>
        
        {/* There's an AI for That Badge */}
        <a 
          href="https://theresanaiforthat.com/ai/newsforyou-ai/?ref=featured&v=3721985" 
          target="_blank"
          rel="nofollow"
          onClick={handleAIForThatClick}
          className="inline-block opacity-70 hover:opacity-100 transition-opacity duration-300"
          style={{ filter: 'brightness(1.4)' }}
        >
          <img 
            src="https://media.theresanaiforthat.com/featured-on-taaft.png?width=600"
            alt={t('header.aiForThatBadgeAlt')}
            className="w-40 h-8 object-contain"
            width="160" 
            height="32"
            loading="lazy"
            style={{ filter: 'invert()' }}
          />
        </a>
      </div>
    </div>
  );
};
